import { IntersectionOptions, InViewHookResponse, useInView } from "react-intersection-observer";

type IntersectionObserverForStickyBottomSheetHookResponse = InViewHookResponse & {
  shouldDisplayStickyBottomSheet: boolean;
};

export function useIntersectionObserverForStickyBottomSheet(
  options?: IntersectionOptions,
): IntersectionObserverForStickyBottomSheetHookResponse {
  const inViewHookResponse = useInView(options);

  // StickyBottomSheet should only appear if referenced Element is above viewport's top edge (-> scroll direction bottom).
  const isReferencedElementBeyondTopEdge =
    (inViewHookResponse.entry && inViewHookResponse.entry.boundingClientRect.top < 0) ?? false;

  const shouldDisplayStickyBottomSheet = !inViewHookResponse.inView && isReferencedElementBeyondTopEdge;

  return {
    ...inViewHookResponse,
    shouldDisplayStickyBottomSheet,
  } as IntersectionObserverForStickyBottomSheetHookResponse;
}
